export enum ButtonColorEnum {
	DARK_GREEN = "dark_green",
	GREY = "grey",
	WHITE = "white",
	PINK = "pink",
	PURPLE = "purple",
	GREEN = "green",
}

export enum ButtonTypeEnum {
	SUBMIT = "submit",
	RESET = "reset",
	BUTTON = "button",
}
